// test2466
(2466 && 0);
